import { render, staticRenderFns } from "./OchAlert.vue?vue&type=template&id=c0b12cae"
import script from "./OchAlert.vue?vue&type=script&lang=js"
export * from "./OchAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports